@if (error()) {
<div class="http-error">
  <p i18n="@@S_ATTRIBUTE_FILTER_HTTP_ERROR_TITLE">Something went wrong</p>
  <span i18n="@@S_ATTRIBUTE_FILTER_HTTP_ERROR_DESCRIPTION">Please try again later</span>
  <button i18n="@@S_ATTRIBUTE_CHIPS_BUTTON_REFRESH" mat-button class="primary" (click)="refreshClicked.emit()">REFRESH</button>
</div>
} @else if (loading()) {
<div class="loading-container">
  <mat-spinner diameter="32"></mat-spinner>
</div>
} @else {
<mat-form-field class="search-field" appearance="outline">
  <div class="search-field__container">
    <mat-icon matPrefix svgIcon="ds-ic-search"></mat-icon>
    <input
      matInput
      placeholder="Search attributes"
      i18n-placeholder="@@S_ATTRIBUTE_FILTER_SEARCH_PLACEHOLDER"
      [formControl]="searchFormControl"
    />
    <mat-icon matSuffix svgIcon="ds-ic-close" (click)="searchFormControl.setValue('')" [class.hidden]="!searchFormControl.value"></mat-icon>
  </div>
</mat-form-field>
<!-- <button class="deselect-button" mat-button>DESELECT ALL</button> -->
@if (isMaxSelectionReached()) {
<p class="max-selection-error" i18n="@@S_ATTRIBUTE_FILTER_MAX_SELECTION_ERROR">
  You have exceeded the number of attributes you can have applied at one time.
</p>
} @if (hasAttributes()) {
<cdk-virtual-scroll-viewport [itemSize]="32" class="tree-viewport">
  <ng-container *cdkVirtualFor="let item of expandedNodesDataSource; trackBy: trackById"></ng-container>

  <cdk-tree [class.hidden]="!hasFilterResult()" [dataSource]="treeDataSource" [treeControl]="treeControl" [trackBy]="trackById">
    <cdk-tree-node *cdkTreeNodeDef="let node" class="tree-node" [style.padding-left.px]="node.level * 24 + 48">
      <mat-checkbox
        [disabled]="!node.isChecked && !node.isIndeterminate && isMaxSelectionReached()"
        [checked]="node.isChecked"
        [indeterminate]="node.isIndeterminate"
        (change)="toggleNode(node)"
      >
        <span [innerHTML]="node.name | highlight: searchDebounceValue()"></span>
      </mat-checkbox>
    </cdk-tree-node>

    <cdk-tree-node *cdkTreeNodeDef="let node; when: hasChild" class="tree-node" [style.padding-left.px]="node.level * 24 + 24">
      <mat-icon
        class="tree-node__toggle"
        (click)="toggleExpand(node)"
        [svgIcon]="node.isExpanded ? 'ds-ic-arrowDown' : 'ds-ic-arrowRight'"
      ></mat-icon>
      <mat-checkbox
        [disabled]="!node.isChecked && !node.isIndeterminate && isMaxSelectionReached()"
        [checked]="node.isChecked"
        [indeterminate]="node.isIndeterminate"
        (change)="toggleNode(node)"
      >
        <span [innerHTML]="node.name | highlight: searchDebounceValue()"></span>
      </mat-checkbox>
    </cdk-tree-node>
  </cdk-tree>
</cdk-virtual-scroll-viewport>
@if (!hasFilterResult()) {
<div class="no-results">
  <p i18n="@@S_ATTRIBUTE_FILTER_NO_RESULTS_TITLE">No results</p>
  <span i18n="@@S_ATTRIBUTE_FILTER_NO_RESULTS_DESCRIPTION">Try adjusting your search</span>
</div>
} } @else {
<div class="no-attributes">
  <p>No attributes available</p>
  <span>Create and assign attributes so you can filter on the LiveMap</span>
</div>
} }

<mat-divider></mat-divider>
<div class="footer">
  <button class="tertiary" [disabled]="disableReset()" mat-button (click)="reset()" i18n="@@S_ATTRIBUTE_FILTER_BUTTON_RESET">RESET</button>
  <button
    [disabled]="disableApply() || isMaxSelectionReached()"
    mat-button
    class="primary"
    (click)="apply()"
    i18n="@@S_ATTRIBUTE_FILTER_BUTTON_APPLY"
  >
    APPLY
  </button>
</div>
